/*
 * @Author: wanglongx
 * @Date: 2019-05-10 10:39:14
 * @LastEditors: wanglongx
 * @desc 外层方案修改
 * @LastEditTime: 2020-08-04 13:49:09
 */

import React, { Component } from 'react';
import { Dropdown, Input, HotKeys as NCHotKeys, Tooltip as NCTooltip } from '@platform/base';
// query items 
import { toast } from '@platform/api';
export default class Item extends Component {

    style = {};
    state = {
        value: this.props.value,
        showFlag: true,
        isHover: false,
        showSearchNameTip: false
    }
    // componentDidUpdate() {
    //     if (this.currentPlanIcon) {
    //         this.currentPlanIcon.scrollIntoView();
    //     }
    // }
    componentDidMount() {
        if (this.currentPlanIcon) {
            this.currentPlanIcon.scrollIntoView();
        }
    }
    componentWillReceiveProps(nextProps, nextState) {
        if ('showFlag' in nextProps) {
            this.setState({ showFlag: nextProps.showFlag });
        }
        if ('value' in nextProps) {
            this.setState({ value: nextProps.value });
        }
    }



    handleChange = v => {
        this.setState({ value: v });
    }

    // 确定按钮时 名称重复校验 空校验
    handleConfirm = e => {
        const { searchInfo, multiLang, value, editSearchPlan, beSureBtnClick } = this.props;
        if (e) {
            e.stopPropagation();
        }
        if (this.state.value === value) {
            this.setState({ showFlag: true });
            return;
        } else if (searchInfo.searchPlanCache.find(item => item.name === this.state.value) !== undefined) {
            {
                toast({ content: multiLang['page-search-0083'], color: 'warning' });
            }
            this.setState({ showFlag: false });
            return;
        } else if (this.state.value.replace(/\s+/g, '') === '') {
            {
                toast({ content: multiLang['page-search-0032'], color: 'warning' });
            }
            this.setState({ showFlag: false });
            return;
        }
        this.setState({ showFlag: true });
        beSureBtnClick(this.state.value)
    }

    render() {

        const { chooseSearchPlan, item, searchAdvBtnClick, delSearchPlan, multiLang, searchInfo, value, setDefaultScheme, meta } = this.props;
        const current = searchInfo.currentPlan || searchInfo.defaultPlan;
        let currentPlan = current.name;
        const currentpk = current.pk_ncc_queryscheme;
        let defaultDisPlay = meta.defaultDisPlay;
        if (defaultDisPlay === '00000000000000000000') {
            defaultDisPlay = '001';
        }
        searchInfo.defaultScheme = searchInfo.searchPlanCache.filter(i => i.pk_ncc_queryscheme === (defaultDisPlay || meta.defaultPrepared));
        let iconClass = item.pk_ncc_queryscheme === (defaultDisPlay || meta.defaultPrepared) ? ' iconfont-def' : '';
        let itemClass = currentPlan === value ? ' item-current' : '';
        let editClass = this.state.showFlag ? '' : ' item-edit';
        return (
            <div className={'query_item' + itemClass + editClass + ' '} ref={dom => {
                this.searchPlanDom = ReactDOM.findDOMNode(dom);
                if (this.searchPlanDom) {
                    this.searchPlanIcon = this.searchPlanDom.querySelector('.search-plan-set');
                    this.defaultIcon = this.searchPlanDom.querySelector('.iconfont-default-hover');
                    this.currentPlanIcon = this.searchPlanDom.querySelector('.iconfont-current-plan');
                }
            }}
                onMouseEnter={(e) => {
                    e.stopPropagation();
                    if (this.searchPlanIcon) {
                        this.searchPlanIcon.style.display = "flex";
                    }
                    if (this.searchPlanDom) {
                        this.searchPlanDom.classList.add('item-current');
                    }
                    if (this.defaultIcon) {
                        this.defaultIcon.style.display = "none";
                    }
                }}
                onMouseLeave={(e) => {
                    e.stopPropagation();
                    if (this.searchPlanIcon) {
                        this.searchPlanIcon.style.display = "none";
                    }
                    if (!itemClass && this.searchPlanDom) {
                        this.searchPlanDom.classList.remove('item-current');
                    }
                    if (this.defaultIcon) {
                        this.defaultIcon.style.display = "inline";
                    }
                }}
            >
                {
                    this.state.showFlag ?
                        (

                            <div className="search_planName_flag" onClick={chooseSearchPlan}>
                                <NCTooltip
                                    delayShow={800}
                                    inverse
                                    delayHide={1}
                                    overlay={this.state.showSearchNameTip ? this.state.value : null}
                                    placement="top"
                                >
                                    <span className="search_planName"
                                        onMouseOver={(e) => {
                                            e.stopPropagation();
                                            if (e.target && e.target.scrollWidth > e.target.clientWidth) {
                                                if (this.state.showSearchNameTip) return;
                                                this.setState({ showSearchNameTip: true });
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (!this.state.showSearchNameTip) return;
                                            this.setState({ showSearchNameTip: false });
                                        }}
                                    >{this.state.value}</span></NCTooltip>
                                {currentPlan == this.state.value && currentpk == this.props.item.pk_ncc_queryscheme ? <i className="iconfont iconfont-current-plan icon-liucheng1" /> : null}
                            </div>



                        ) : (
                            <NCHotKeys
                                keyMap={{
                                    high: [
                                        'enter',
                                    ],
                                }}
                                handlers={{ high: this.handleConfirm }}
                            >
                                <Input
                                    className="search_input icon-not-visible"
                                    autoFocus={true}
                                    value={this.state.value}
                                    onClick={e => {
                                        e.stopPropagation();
                                    }}
                                    onChange={v => {
                                        this.setState({ value: v });
                                    }}
                                />
                            </NCHotKeys>
                        )
                }
                {
                    this.state.showFlag ? (
                        <>
                            {iconClass && <i className="iconfont icon-not-visible iconfont-default-hover icon-sheweimoren" />}
                            <span
                                className="search-plan-set"
                            >
                                <NCTooltip
                                    delayShow={800}
                                    inverse
                                    delayHide={1}
                                    overlay={multiLang['page-search-0093']}
                                    placement="top"
                                >
                                    <i
                                        className="iconfont icon-cxzhongmingming"
                                        onClick={searchAdvBtnClick}
                                    />
                                </NCTooltip>
                                <NCTooltip
                                    delayShow={800}
                                    delayHide={1}
                                    inverse
                                    overlay={iconClass ? multiLang['page-search-0097'] : multiLang['page-search-0095']}
                                    placement="top"
                                >
                                    <i
                                        className={"iconfont icon-not-visible iconfont-second icon-sheweimoren" + iconClass}
                                        onClick={e => {
                                            e.stopPropagation();
                                            if (iconClass) return;
                                            setDefaultScheme(item.pk_ncc_queryscheme);
                                        }}
                                    />
                                </NCTooltip>
                                {!(item.isMyPlan || item.isprepared) && <div
                                    className='hover-icon'
                                    onMouseEnter={e => {
                                        let position = e.target?.getBoundingClientRect();
                                        if (position) {
                                            this.style.top = (Math.round(position.bottom)) + 'px';
                                            this.style.left = (Math.round(position.right) - 18) + 'px';
                                        }
                                        if (this.searchPlanDom) {
                                            this.searchPlanDom.classList.add('item-current');
                                        }
                                        if (this.searchPlanIcon) {
                                            this.searchPlanIcon.style.display = "flex";
                                        }
                                        this.setState({ isHover: true })
                                    }}
                                    onMouseLeave={e => {
                                        this.setState({ isHover: false })
                                    }}>
                                    <i className="iconfont icon-not-visible icon-gengduo" />
                                    {this.state.isHover && ReactDOM.createPortal(<ul className="menu_items second_level" style={this.style}>
                                        <li
                                            className='menulist icon-not-visible'
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                this.setState({ showFlag: false, isHover: false });//重命名
                                            }}
                                        >
                                            {multiLang['page-search-0092']}
                                        </li>
                                        <li className='menulist icon-not-visible'
                                            onClick={e => {
                                                e.stopPropagation();//删除
                                                delSearchPlan();
                                            }}>{multiLang['page-search-icon-delete']}</li>
                                    </ul>, document.body)}
                                </div>}
                            </span>
                        </>

                    ) : (
                        <div className="search-list-button">
                            <span
                                className="button-item icon-not-visible right"
                                onClick={this.handleConfirm}
                            >
                                {multiLang['page-search-0009']}
                            </span>
                            <span
                                className="button-item icon-not-visible left"
                                onClick={e => {
                                    e.stopPropagation();
                                    this.setState({
                                        showFlag: true,
                                        value: this.props.value,
                                    });
                                }}
                            >
                                {multiLang['page-search-0010']}
                            </span>
                        </div>
                    )
                }
            </ div >
        );
    }

}